module.exports = __webpack_public_path__ + "f2fb2f3ed3be5f812f8073eb4bf1a765.jpg";